import './breadcrumbs.scss';
import { Icon } from '@rocketmakers/armstrong';
import * as React from 'react';
import { icons } from '../../content/icons';
import { LinkWrapper } from '../linkWrapper';
import { Tag } from '../tag';
import { ExpandingRegion } from './expandingRegion';
import { RMButton } from './rmButton';
export const Breadcrumbs = ({ crumbs, tags, expandable, cancel, children }) => {
    const [open, setOpen] = React.useState(false);
    return (<div className="breadcrumbs-wrapper">
      <div className="breadcrumbs">
        <div className="breadcrumbs-inner">
          <div className="breadcrumbs-left">
            {tags?.map((tag) => (<Tag {...tag} key={tag.content}/>))}

            {crumbs?.map((crumb, index) => (<LinkWrapper to={crumb.to} key={crumb.title || index + crumb.icon?.icon}>
                <div className="crumb" key={crumb.title || index} data-link={!!crumb.to}>
                  {crumb.icon && <Icon {...crumb.icon}/>}
                  {crumb.title && <p>{crumb.title}</p>}
                </div>
              </LinkWrapper>))}
          </div>

          <div className="breadcrumbs-right">
            {cancel && (<RMButton variant="flat" rightIcon={icons.cancel} to={cancel.to}>
                {cancel.text}
              </RMButton>)}
            {expandable && (<RMButton variant="flat" onClick={() => setOpen(!open)} rightIcon={open ? expandable.closeIcon : expandable.openIcon}>
                {open ? expandable.closeText : expandable.openText}
              </RMButton>)}
          </div>
        </div>

        {expandable && children && <ExpandingRegion expanded={open}>{children}</ExpandingRegion>}
      </div>
    </div>);
};
